import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { OdlBeforeCloseEvent } from '@odilo/ui-components';
import { TranslatePipe } from '@ngx-translate/core';
import { MetadataService } from '../../services/metadata/metadata';
import { NavigateService } from '../../services/navigate/navigate';

@Component({
  selector: 'nr-unauthorized-dialog',
  imports: [TranslatePipe],
  templateUrl: './unauthorized-dialog.html',
  styleUrl: './unauthorized-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UnauthorizedDialogComponent {
  private readonly metadataService = inject(MetadataService);
  private readonly navigateService = inject(NavigateService);

  readonly isUnauthorized = this.metadataService.isUnauthorized;

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  preventClose(event: Event): void {
    if (event instanceof OdlBeforeCloseEvent && event.detail.source !== 'programmatic') {
      event.preventDefault();
    }
  }

  goToPlatform(): void {
    this.navigateService.goToPlatform();
  }
}
